import { render, staticRenderFns } from "./OtpComponent.vue?vue&type=template&id=9939306e"
import script from "./OtpComponent.vue?vue&type=script&lang=ts"
export * from "./OtpComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports